import React from 'react';
import { IProps, IChildElement } from 'components/Home/InsureRules/types';
import TravelInsureRules from 'components/Home/InsureRules/TravelInsureRules';
import CarInsureRules from 'components/Home/InsureRules/CarInsureRules';
import MotoInsureRules from 'components/Home/InsureRules/MotoInsureRules';
import MobileDeviceRules from 'components/Home/InsureRules/MobileDeviceRules';
import FireInsureRules from 'components/Home/InsureRules/FireInsureRules';

const InsureRules: React.FC<IProps> & IChildElement = (props) => (
  <div className="insure-rules" id={props.isPet ? 'insure-rules-pet' : undefined}>
    <div className="template-container">
      <div className="template-content" style={props.styles}>
        <div className="insure-rules__title-section">
          {!props.isPet && <div className="insure-rules__title">投保規則</div>}
        </div>
        {props.children}
      </div>
    </div>
  </div>
);

InsureRules.TravelInsureRules = TravelInsureRules;
InsureRules.CarInsureRules = CarInsureRules;
InsureRules.MotoInsureRules = MotoInsureRules;
InsureRules.MobileDeviceRules = MobileDeviceRules;
InsureRules.FireInsureRules = FireInsureRules;

export default InsureRules;
